import { useTranslation } from 'react-i18next';
type payMethodProps = {
  pay: string;
};
// 'pm01', // 포인트 결제
// 'pm02', // 신용카드
// 'pm03', // 계좌 이체
// 'pm04', // 가상 계좌 (무통장 입금)
// 'pm05', // 크립토 환전

export default function PayMethod({ pay }: payMethodProps) {
  const { t } = useTranslation();
  return <>{t(`pay.${pay}`)} </>;
}
